export default "__VITE_ASSET__CdwTMEcr__"